export default __webpack_public_path__ + "static/media/img_gas_phase_en_05.918c7f7e.png";